import React from "react"
import { Link } from "gatsby"
import BgTravel from "../../images/word-travel.jpg"

const WorkTravel = () => {
  return (
    <section
      className="bg-cover bg-center bg-no-repeat text-white text-center text-shadow"
      style={{ backgroundImage: `url(${BgTravel})` }}
    >
      <div className="bg-opacity-50 bg-primary py-20">
        <div className="container mx-auto px-6">
          <h3 className="text-6xl md:text-5xl lg:text-7xl pb-8 font-bold">Work & Travel</h3>
          <h4 className="text-3xl mb-8">Travel with us, develop your genius, and live unique experiences!</h4>        
          <Link to="/careers/work-and-travel" title="Work & Travel" className="mx-auto border-white border-solid border-2 hover:bg-neutral hover:text-variant hover:text-primary btn">Know us</Link>
        </div>
      </div>
    </section>
  )
}

export default WorkTravel
